import type { PostHogBootstrap } from "../../core";
import { createContext } from "../../utils/create-context";

export type FeatureFlagContext = {
  bootstrap?: PostHogBootstrap;
};

const [useFeatureFlagContext, FeatureFlagContextProvider] = createContext<FeatureFlagContext>();

export { FeatureFlagContextProvider, useFeatureFlagContext };
